export enum SentTypeEmail {
  SEND_CHANGE_PASSWORD = "send_change_password"
}
